import { commonParams, api, ERR_OK } from './config';
import axios from '../common/js/axiox';

export async function getActivityList(userId) {
  return await axios.get(`${api.activityUrl}/${userId}`).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

export async function addActivity(activity) {
  return await axios.post(api.activityUrl, activity).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

export async function deleteActivity(userId, uuid) {
  return await axios.put(api.activityUrl, {
    userId,
    psUUID: uuid
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

export async function getActivityCourseList(userId) {
  return await axios.get(`${api.activityCourseUrl}/${userId}`).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

export async function getInActivityCourseList(userId) {
  return await axios.get(`${api.inActivityCourseUrl}/${userId}`).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

export async function addActivityCourses(userId, uuids) {
  return await axios.post(api.activityCourseUrl, {
    userId,
    courseUUIDs: uuids
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });

}
export async function deleteActivityCourses(userId, uuids) {
  return await axios.put(api.activityCourseUrl, {
    userId,
    courseUUIDs: uuids
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}